// categoryShowcase.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Row } from "react-bootstrap";
import { GrView } from "react-icons/gr";
import { MdAdsClick } from "react-icons/md";
import { elakay_API, resolveCategoryImageUrl } from "../../config";
import ShowimagesLoading from "./showImagesLoading";
import CategoryMatrixPreview from "./CategoryMatrixPreview";
import "./categoryShowcase.css";

// matrixChildren: the PARENT's Matrix Mode children map (getMatrixChildren,
// CategoryMatrixPreview.jsx) -- set only when the parent of these cards has
// Matrix Mode ON; this card then shows its 4 best sellers instead of its own
// stored image. null/undefined = default mode, unchanged.
export const CategoryCard = ({ item, infoSource, ButtonViewCategories, ar, isActive, matrixChildren }) => {
  const cat = item?.supCategoryID;
  if (!cat) return null;

  // DB URL first (image_r.photoUrl / urlImg); the constructed `/pubR/:id`
  // route is only a last-resort fallback for a category with no stored
  // rectangle image at all -- see resolveCategoryImageUrl() (config.js).
  const catImageUrl = resolveCategoryImageUrl(cat, { variant: "rectangle" }) || `${elakay_API}/pubR/${cat._id}`;

  return (
    <div className="col p-2">
      <div className={`ec-cat-card${isActive ? " ec-cat-card--active" : ""}`}>
        <div className="ec-cat-media">
          {matrixChildren ? (
            <CategoryMatrixPreview
              products={matrixChildren[String(cat._id)] || []}
              label={infoSource.getCategoryNames(item).name[0]}
              fallbackSrc={catImageUrl}
            />
          ) : (
          <ShowimagesLoading
            className="ec-cat-img"
            src={catImageUrl}
            alt={cat.name?.[0]}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          )}
          <Link
            to={`/product/${cat.publicId || cat._id}`}
            className="ec-cat-viewlink"
            title={infoSource.laguangeElakay("title", infoSource.languageAPI).viewPage}
            onClick={(e) => e.stopPropagation()}
          >
            <GrView />
          </Link>
        </div>
        <button
          type="button"
          className="ec-cat-overlay"
          onClick={() => ButtonViewCategories(ar, cat, cat._id)}
        >
          <span className="ec-cat-name">{infoSource.getCategoryNames(item).name[0]}</span>
          <span className="ec-cat-icon"><MdAdsClick /></span>
        </button>
      </div>
    </div>
  );
};

const CategoryShowcaseGrid = ({ items, ar, infoSource, ButtonViewCategories, activeId, matrixChildren }) => {
  if (!items || items.length === 0) return null;

  return (
    <Row xs={2} sm={2} md={3} lg={3} xl={4} className="g-0">
      {items.map((m, i) => (
        <CategoryCard
          key={m?.supCategoryID?._id || i}
          item={m}
          ar={ar || items}
          infoSource={infoSource}
          ButtonViewCategories={ButtonViewCategories}
          isActive={activeId === m?.supCategoryID?._id}
          matrixChildren={matrixChildren}
        />
      ))}
    </Row>
  );
};

export default CategoryShowcaseGrid;
